import {Box, Stack, Typography} from "@mui/material";
import coin from "../../public/coin-svgrepo-com.svg";
import {EffectType} from "../shared/types/EffectType";
import {MediaSkeleton} from "../shared/ui/MediaSkeleton.tsx";
import {memo, useState} from "react";
import {liquidGlassStyle} from "../app/theme/liquidGlassStyle.ts";
import {VideoIcon} from "../shared/ui/VideoIcon.tsx";

interface IVideoEffectCardProps {
    effect: EffectType;
    onClick?: () => void;
}

export const VideoEffectCard = memo(({effect, onClick}: IVideoEffectCardProps) => {
    const {imgSrc, title, price, isCustom} = effect;
    const [isLoaded, setIsLoaded] = useState(false);

    if (isCustom) {
        return (
            <Stack
                direction={'column'}
                alignItems={'center'}
                justifyContent={'center'}
                padding={'0 4px'}
                spacing={0}
                onClick={onClick}
                sx={{
                    cursor: 'pointer',
                    width: '100px',
                    height: '140px',
                    borderRadius: '12px',
                    position: 'relative',
                    ...liquidGlassStyle,
                    '@media (hover: hover)': {
                        '&:hover': {
                            opacity: '0.8'
                        }
                    }
                }}
            >
                <Typography variant={'h6'} sx={{opacity: 0.9, textAlign: 'center', fontWeight: 600}}>{title}</Typography>
                <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px'}}>
                    <Typography sx={{textAlign: 'center', fontSize: '14px', margin: 0}}>{price}</Typography>
                    <Box component={'img'} src={coin} alt={'coin'} width={'12px'} height={'12px'} sx={{opacity: 0.8, margin: 0}}/>
                </Box>
                 <VideoIcon />
            </Stack>
        );
    }

    return (
        <Stack direction={'column'} alignItems={'center'} padding={'0 4px'} spacing={'8px'}  sx={{
            cursor: 'pointer',
            width: '100px',
            height: '140px',
            borderRadius: '12px',
            '@media (hover: hover)': {
                '&:hover': {
                    opacity: '0.8'
                }
            }
        }}>
            <Box position={'relative'} onClick={onClick} >
                {!isLoaded && imgSrc && (
                    <MediaSkeleton
                        width="100px"
                        height="135px"
                        borderRadius="12px"
                    />
                )}
                {imgSrc && (
                    <Box
                        component="img"
                        src={imgSrc}
                        alt={title}
                        onLoad={() => setIsLoaded(true)}
                        sx={{
                            width: '100px',
                            height: '135px',
                            borderRadius: '12px',
                            objectFit: 'cover',
                            objectPosition: 'top',
                            display: isLoaded ? 'block' : 'none'
                        }}
                    />
                )}
                <Stack direction={'row'} spacing={'2px'} alignItems={'center'} justifyContent={'center'}
                       position={'absolute'} top={'105px'} left={'45px'} sx={{backdropFilter: 'blur(10px)'}} width={'fit-content'} height={'fit-content'} padding={'3px 5px'}
                       borderRadius={'6px'}>
                    <Typography sx={{textAlign: 'center'}}>{price}</Typography>
                    <Box component={'img'} src={coin} alt={'coin'} width={'12px'} height={'12px'}
                         sx={{opacity: 0.8}}/>
                </Stack>

            </Box>
                <Typography variant={'h6'} sx={{opacity: 0.7, textAlign: 'center'}}>{title}</Typography>

        </Stack>
    )
})
